import styled from 'styled-components';

type SingleInputProps = {
  width: number,
  font: number,
}

const SingleInput = styled.input<SingleInputProps>`
  width: ${({ width }) => width}px;
  padding: 0px;
  font-size: ${({ font }) => font}px;
  text-align: center;
  border: 2px solid;
  border-radius: 5px;
  overflow: visible;
  border-color: ${({ theme }) => (theme.colors.gray)};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => (theme.colors.navy)};

  &:focus {
    border-color: transparent !important;
    box-shadow: 0 0 0px 2.5px #2684ff;
    z-index: 10;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray};
  }

`;

export const Styled = {
  SingleInput,
};
